export function isDate(d: any) {
  return d instanceof Date && !isNaN(d.valueOf());
}
